module.exports = function(item) {
  if(item === undefined)  return [];
  return Object.prototype.toString.call(item) === "[object Array]" ? item : [item];
}


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/toarray/index.js
 ** module id = 1132
 ** module chunks = 0
 **/